import React, { useState } from "react";
import { FaTrash } from "react-icons/fa";
import { connect } from "react-redux";
import
{
    Button,
    Card,
    CardBody,
    Modal,
} from "reactstrap";
const DeleteModal = ({  confirm, buttonText, confirmText }) =>
{
    let [modal, toggleModal] = useState(false);


    return (
        <div>
            <Button
                color='danger'
                className='btn-sm mb-1'
                onClick={() => toggleModal(true)}
                

            >
                <FaTrash />
            </Button>
            <Modal
                className='modal-dialog-centered'
                isOpen={modal}
                toggle={() => toggleModal(false)}
            >
                <div className='modal-body p-2'>
                    <Card className='bg-secondary shadow border-0'>
                        <CardBody className='px-lg-5 py-lg-2'>
                            <p>{confirmText}</p>

                            <div className='text-center mt-4'>
                                <Button
                                    onClick={() => toggleModal(false)}
                                    color='danger'
                                    className='btn-sm'
                                >
                                    No
                                </Button>
                                <Button color='success' onClick={() => { toggleModal(false); confirm() }} className='btn-sm' type='submit'>
                                    Si
                                </Button>
                            </div>
                        </CardBody>
                    </Card>
                </div>
            </Modal>
        </div>
    );
};

export default connect()(DeleteModal);
